import React from "react";
import {
  PrivateOfficeUpdateRequest,
  PictureProperty,
  CurrentRoomImages,
} from "@/services/private-office-service/types";
import { isImageRequest, isImageDeletionRequest } from "@/utils/image-utils";
import { PendingImageRequest } from "./pending-image-request";
import { PendingImageDeletionRequest } from "./pending-image-deletion-request";
import { ApprovedImageRequest } from "./approved-image-request";
import { RejectedImageRequest } from "./rejected-image-request";

interface ImageRequestHandlerProps {
  request: PrivateOfficeUpdateRequest;
  onApproved: (data: PrivateOfficeUpdateRequest) => void;
  onRejected: (data: PrivateOfficeUpdateRequest) => void;
  roomImages?: CurrentRoomImages;
  onImageSlotApplied?: (
    roomId: number,
    property: PictureProperty,
    url: string | null,
  ) => void;
}

export const ImageRequestHandler: React.FC<ImageRequestHandlerProps> = ({
  request,
  onApproved,
  onRejected,
  roomImages,
  onImageSlotApplied,
}) => {
  if (!isImageRequest(request.fields_to_update)) {
    return null;
  }

  switch (request.status) {
    case "pending":
      // Check if this is an image deletion request
      if (isImageDeletionRequest(request.fields_to_update)) {
        return (
          <PendingImageDeletionRequest
            request={request}
            onApproved={onApproved}
            onRejected={onRejected}
            onImageSlotApplied={onImageSlotApplied}
          />
        );
      } else {
        return (
          <PendingImageRequest
            request={request}
            onApproved={onApproved}
            onRejected={onRejected}
            roomImages={roomImages}
            onImageSlotApplied={onImageSlotApplied}
          />
        );
      }

    case "approved":
      return <ApprovedImageRequest request={request} />;

    case "rejected":
      return <RejectedImageRequest request={request} />;

    default:
      return null;
  }
};
